import React from 'react';
import './App.css';
import Navbar from './Components/Navbar';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './Components/pages/Home';
import SeriesOne from './Components/pages/GalleryOne';
import SeriesFour from './Components/pages/GalleryFour';
import SeriesFive from './Components/pages/GalleryFive';
import Works from './Components/pages/HowItWorks';
import About from './Components/pages/AboutMe';
import Protocol from './Components/pages/BuyingProtocol';

import ScrollToTop from './Components/ScrollToTop';


function App() {


  return (
    
    
    <>
      <Router>
        <ScrollToTop />
          
            <Navbar />
          
       <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path= '/galleryOne' element={<SeriesOne/>}/>
        <Route path= '/galleryFour' element={<SeriesFour/>}/>
        <Route path= '/galleryFive' element={<SeriesFive/>}/>
        <Route path= '/HowItWorks' element={<Works/>}/>
        <Route path= '/AboutMe' element={<About/>}/>
        <Route path= '/BuyingProtocol' element={<Protocol/>}/>
       </Routes>
      </Router>
    </>
  );
}

export default App;
